<script setup>
  import { computed } from 'vue';
  import Gallery from '@/components/Paragraphs/Gallery.vue';
  import Text from '@/components/Paragraphs/Text.vue';

  const props = defineProps({
    item: Object
  })

  const components = {
    'element-text': Text,
    'element-gallery': Gallery
  }

  const tagItems = computed(() => {
    if (!props.item.items) return false
    return props.item.items
  })

</script>

<template>
  <div
    class="element-tag-item"
  >
    <component
      v-for="(item, key) in tagItems"
      :is="components[item.element]"
      :isTab="true"
      :text="item.text"
    />
  </div>
</template>

<style lang="scss" scoped>

</style>
